import React, { FC } from 'react';
import styled from 'styled-components';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';
import Typography from '../../Typography';

import i18n from 'i18n';
import { AppType } from '../../../../constants';

const IsPaidNotice = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
`;

interface AppIsPaidModalProps extends ModalProps {}

export const AppIsPaidModal: FC<AppIsPaidModalProps> = ({
  app,
  onSuccess,
  onCancel,
}) => {
  const appType = app.type;
  let texts;

  if (appType === AppType.CLOCK.toUpperCase()) {
    texts = {
      itemIsPaidText: 'component.AppIsPaidModal.textClock',
      changeMindText: 'component.AppIsPaidModal.changeMindClock',
      galleryText: 'component.AppIsPaidModal.fitbitClockGallery',
    };
  } else {
    texts = {
      itemIsPaidText: 'component.AppIsPaidModal.textApp',
      changeMindText: 'component.AppIsPaidModal.changeMindApp',
      galleryText: 'component.AppIsPaidModal.fitbitAppGallery',
    };
  }

  return (
    <Dialog
      show={true}
      id="AppIsPaidModal"
      heroIcon="wallet"
      title={i18n('component.AppIsPaidModal.title')({ appName: app.name })}
      onDismiss={onCancel}
      actions={[
        {
          text: i18n('component.PermissionModal.disallowButtonText')(),
          onClick: onCancel,
          variant: 'text',
          id: 'app-is-paid-button-cancel',
        },
        {
          text: i18n('component.PermissionModal.allowButtonText')(),
          onClick: onSuccess,
          variant: 'filled',
          id: 'app-is-paid-button-ok',
        },
      ]}
    >
      <IsPaidNotice>
        <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
          {i18n(texts.itemIsPaidText)()}
          <strong>{i18n('component.AppIsPaidModal.notEndorsed')()}</strong>
        </Typography>
        <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
          <strong>
            {i18n('component.AppIsPaidModal.caution')()}
          </strong>
        </Typography>
        <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)" style={{ marginTop: '12px' }}>
          {i18n(texts.changeMindText)()}
          <strong style={{ textTransform: 'capitalize' }}>
            {i18n(texts.galleryText)()}
          </strong>
        </Typography>
      </IsPaidNotice>
    </Dialog>
  );
};

export default AppIsPaidModal;
